import { Component, Input, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

@Component({
   selector: 'samweb-home-bar-item',
   templateUrl: './home-bar-item.component.html',
   styleUrls: ['./home-bar-item.component.scss'],
})
export class HomeBarItemComponent implements OnInit {
   @Input()
   menuItemIcon: IconDefinition;

   @Input()
   menuStackedItemIcon: IconDefinition = null;

   @Input()
   menuStackedItemClass: string;

   @Input()
   menuItemTranslationKey: string;

   constructor() {}

   ngOnInit() {}
}
